import React from 'react';
import './termsConditions.scss';
import NumberedComponent from "./components/NumberedComponent";

const TermsConditionsSection = () => {
	return (
		<div className="termsConditionsSection">
			<div className="termsConditionsSection__content">
				<div className="termsConditionsSection__content_start">
					<h1>Terms and Conditions</h1>
					<span>Welcome to [Your Website Name] ("we," "our," "us"). These Terms and Conditions govern your use of our website [Your Website URL] (the "Site"). By accessing or using our Site, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use our Site.</span>
				</div>
				<div className="termsConditionsSection__content_list">
					<NumberedComponent
						index={'1'}
						title={'Use of the Site'}
						list={[
							'Eligibility: You must be at least [Insert Minimum Age] years old to use our Site. By using the Site, you represent and warrant that you meet this age requirement.',
							'Account Registration: To access certain features of the Site, you may be required to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.',
							'Prohibited Activities: You agree not to use the Site for any unlawful purpose or in any way that could damage, disable, overburden, or impair the Site. Prohibited activities include, but are not limited to, hacking, data mining, and transmitting any malicious software.'
						]}
					/>
					<NumberedComponent
						index={'2'}
						title={'Intellectual Property'}
						list={[
							'Ownership: All content on the Site, including text, graphics, logos, images, and software, is the property of [Your Company Name] or its licensors and is protected by intellectual property laws.',
							'License: We grant you a limited, non-exclusive, non-transferable license to access and use the Site for personal, non-commercial purposes. You may not reproduce, distribute, modify, or create derivative works of any content without our prior written consent.'
						]}
					/>
					
					<NumberedComponent
						index={'3'}
						title={'Purchases and Payments'}
						list={[
							'Orders: By placing an order on our Site, you agree to provide accurate and complete information. We reserve the right to refuse or cancel any order for any reason, including but not limited to product availability, errors in the product description or price, or suspected fraud.',
							'Payment: All payments are processed through secure payment gateways. You agree to pay all charges incurred by your use of the Site, including any applicable taxes and shipping fees.',
							'Refunds and Returns: Please refer to our [Refund and Return Policy] for detailed information on our refund and return procedures.'
						]}
					/>
					
					<NumberedComponent
						index={'4'}
						title={'User Content'}
						list={[
							'Submission: You may submit content to the Site, such as reviews, comments, and photos. By submitting content, you grant us a non-exclusive, royalty-free, perpetual, and worldwide license to use, reproduce, modify, and display your content.',
							'Responsibility: You are solely responsible for the content you submit. You agree not to submit any content that is unlawful, defamatory, obscene, or otherwise objectionable.'
						]}
					/>
					
					<NumberedComponent
						index={'5'}
						title={'Disclaimers and Limitation of Liability'}
						list={[
							'Disclaimer of Warranties: The Site is provided "as is" and "as available" without any warranties of any kind, either express or implied. We do not guarantee that the Site will be error-free or uninterrupted.',
							'Limitation of Liability: To the fullest extent permitted by law, [Your Company Name] shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of the Site.'
						]}
					/>
					
					<NumberedComponent
						index={'6'}
						title={'Indemnification'}
						description={'You agree to indemnify and hold harmless [Your Company Name] and its affiliates, officers, employees, and agents from any claims, liabilities, damages, losses, or expenses, including reasonable attorneys\' fees, arising out of or in any way connected with your use of the Site or violation of these Terms and Conditions.'}
					/>
					
					<NumberedComponent
						index={'7'}
						title={'Termination'}
						description={'We reserve the right to terminate or suspend your access to the Site at any time, without notice, for any reason, including but not limited to a breach of these Terms and Conditions.'}
					/>
					
					<NumberedComponent
						index={'8'}
						title={'Governing Law'}
						description={'These Terms and Conditions shall be governed by and construed in accordance with the laws of [Your Jurisdiction]. Any disputes arising out of or related to these terms shall be resolved exclusively in the courts of [Your Jurisdiction].'}
					/>
					
					<NumberedComponent
						index={'9'}
						title={'Сhanges to These Terms and Conditions'}
						description={'We may update these Terms and Conditions from time to time. Any changes will be posted on this page with an updated "Last Updated" date. Your continued use of the Site after any changes constitutes your acceptance of the new Terms and Conditions.'}
					/>
				</div>
			</div>
		</div>
	);
};

export default TermsConditionsSection;